<template>
  <div class="ts-flex ts-justify-between ts-items-center ts-w-full">
    <div class="text-right font-weight-bold">
      <span>Total: {{ totalRecords }}</span>
    </div>
    <div class="ts-flex ts-items-center">
      <PerPage :value="perPage" @change="onChangePerPage" />
      <NavPaging :lastPage="lastPage" :currentPage="currentPage" @navigate="navigate" />
    </div>
  </div>
</template>

<script>
import NavPaging from './NavPaging.vue'
import PerPage from './PerPage.vue'

export default {
  name: 'TsPagination',
  components: {
    NavPaging,
    PerPage
  },
  props: {
    value: {
      required: true
    }
  },
  data() {
    return {
      currentPage: null,
      from: null,
      to: null,
      lastPage: null,
      perPage: null,
      total: null,
      loading: false
    }
  },
  computed: {
    totalRecords() {
      return this.total || 0
    }
  },
  watch: {
    value: {
      handler(value) {
        this.setData(value)
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.setData(this.value)
  },
  methods: {
    navigate(page) {
      this.$emit('navigate', {
        page,
        perPage: this.perPage
      })
    },
    onChangePerPage(perPage) {
      this.currentPage = 1
      this.$emit('navigate', {
        page: this.currentPage,
        perPage
      })
    },
    setData(paging) {
      if (paging != null) {
        this.currentPage = paging.currentPage
        this.from = paging.from
        this.to = paging.to
        this.lastPage = paging.lastPage
        this.perPage = paging.perPage
        this.total = paging.total
      }
    }
  }
}
</script>
